// src/App.jsx
import { ThemeProvider } from "./context/ThemeContext";
import { BrowserRouter as Router } from "react-router-dom";
import React, { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes/routes.js";
import { HelmetProvider } from "react-helmet-async";
import "./styles/video-player.css";
import ScrollToTop from "./components/ScrollToTop";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import useAnalytics from "./hooks/useAnalytics";
import FloatingSocialIcons from "./components/floating-icons/FloatingSocialIcons";
import SpecialOfferPopup from "./components/specialOffer/SpecialOfferPopup";
import SpecialOfferFloatingLink from "./components/specialOffer/SpecialOfferFloatingLink";

const Chatbot = React.lazy(() => import("./components/chatbot/Chatbot"));


function AnalyticsTracker() {
  useAnalytics();
  return null;
}

function MetaPixelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
    }
  }, [location]);
  
  return null;
}
const Loading = () => (
  <div className="min-h-screen bg-gray-100 dark:bg-gray-900">
    <div className="animate-pulse p-8 space-y-8">
      <div className="h-12 bg-gray-300 dark:bg-gray-700 rounded w-1/3" />
    </div>
  </div>
);

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isFreightRoute = location.pathname.startsWith("/freight");
  const isConfigureMachine = location.pathname.startsWith("/configure-machine");
  const isQuoteRoute = location.pathname.startsWith("/quote/");
  return (
    <>
      <MetaPixelTracker />
      <AnalyticsTracker />
      <ScrollToTop />
      {isConfigureMachine || isQuoteRoute ? null : isAdminRoute ? null : (
        <Chatbot
          // apiBaseUrl="https://symforklifts.com/api/v1/chat"
          companyName="SYM Machinery"
          primaryColor="#EAB308"
          position="bottom-right"
          initialMessage="Hi! 👋 I'm the SYM Machinery assistant. How can I help you today?"
        />
      )}
      <Suspense fallback={<Loading />}>
        <AppRoutes />
      </Suspense>

      {!isAdminRoute && !isFreightRoute && !isQuoteRoute && <FloatingSocialIcons /> }
      {!isAdminRoute && !isFreightRoute && !isQuoteRoute &&  <SpecialOfferPopup/> }
      {!isAdminRoute && !isFreightRoute && !isQuoteRoute && <SpecialOfferFloatingLink /> }
    </>
  );
}

export default function App() {
  // useMetaPixel();
  return (
    <ThemeProvider>
      <HelmetProvider>
        <Router>
          <AppContent />
        </Router>
      </HelmetProvider>
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          duration: 2000,
          style: {
            background: "#363636",
            color: "#fff",
            fontSize: "16px",
            padding: "16px",
            borderRadius: "12px",
          },
          success: {
            duration: 2000,
            icon: "✅",
            style: {
              background: "#10b981",
            },
          },
          error: {
            duration: 2000,
            icon: "❌",
            style: {
              background: "#ef4444",
            },
          },
        }}
      />
    </ThemeProvider>
  );
}
